module.exports = __webpack_public_path__ + "static/img/iphone.946ce5e.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/download/iphone.png
// module id = g0ub
// module chunks = 70